import {
  CATALOG_ACTOR_AUDIOBOOKS_SET_DATA,
  CATALOG_ACTOR_AUDIOBOOKS_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  actor: null,
  audiobookList: null,
  paginateBy: 48,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  totalBookCount: null,
};

export default function booksetList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_ACTOR_AUDIOBOOKS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_ACTOR_AUDIOBOOKS_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
